import _at from 'lodash-es/at';
import { createSelector } from 'reselect';

import type { SearchSearchHistorySchema } from '@iconik-io/iconik-api/src/services/search';
import type { Entities } from '@iconik-io/shared-lib/src/redux/entities/types';

import type { AppState } from '../../store/types';

const getSearchHistoryEntities = (
  state: AppState,
): Entities<SearchSearchHistorySchema> => state.entities.search_history;

const getSearchHistoryIds = (state: AppState): string[] =>
  state.searchHistoryPanel.searchHistoryIds;

export const selectSearchHistory = createSelector(
  [getSearchHistoryEntities, getSearchHistoryIds],
  (entities, ids) => _at(entities, ids),
);
